import { CallIntelligencePLGService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/plg/v1/plg_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCallIntelligencePLGV1Service = bindHTTP(CallIntelligencePLGService);
export const serviceName = 'call-intelligence-plg-v1' as const;
